// --- Core ---
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
// --- SaniQ ---
import {Resource} from "shared/filter/Filter";
import {FilterDefinition} from "shared/filter/handlers/types";

type FilterState = Partial<Record<Resource, FilterDefinition[]>>;
type CacheFilterDefinition = {
  resource: Resource;
  filterDefinitions: FilterDefinition[];
};

const initialState: FilterState = {};

const filterSlice = createSlice({
  // eslint-disable-next-line formatjs/no-literal-string-in-object
  name: 'filter',
  initialState,
  reducers: {
    cacheFilterDefinition(state, action: PayloadAction<CacheFilterDefinition>) {
      state[action.payload.resource] = action.payload.filterDefinitions;
    }
  }
});

export const {cacheFilterDefinition} = filterSlice.actions;

export default filterSlice.reducer;
